

import { Component, Prop, Vue, Watch } from "vue-property-decorator"

// @ts-ignore
import { BModal } from "bootstrap-vue"

@Component({
	components: {
	}
})
export default class GroupCalculationFilterWarningModal extends Vue {
	@Prop() showModal!: boolean | null

	isOpen: boolean = !!this.showModal;

	@Watch("showModal")
	groupedCalc (newValue: boolean | null) {
		this.isOpen = !!newValue
	}

	private closeModal () {
		this.isOpen = false
	}

	private groupCalculation () {
		if (this.isOpen) {
			this.$emit("groupCalculation")
		}
	}

	private cancelGrouping () {
		if (this.isOpen) {
			this.closeModal()
			this.$emit("cancelGrouping")
		}
	}
}
